import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../../../shared/constants/StyleConstants";
import { ROLE_CONSTANTS } from "@/modules/Roles/constants/RoleConstants";
import { View } from "./../../models/View";

@Component({
  name: "PermissionCard"
})
export default class PermissionCard extends Vue {
  @Prop() views!: View[];

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD_2;
  ROLE_CONST = ROLE_CONSTANTS.PERMISSION_CARD;
  card2Class = STYLE_CLASSES.CARD_PADING;
  allAvailableViews = this.views;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  keyWord = "";
  SEARCH_SCREEN = ROLE_CONSTANTS.PERMISSION_CARD.SEARCH_SCREEN;

  selectDisplay(id: string) {
    this.keyWord = "";
    this.$emit("onDisplay", id);
  }

  get viewsLocal() {
    return this.views.filter(view => !view.show);
  }

  searchScreen(keyWord: string) {
    if (!keyWord) {
      this.allAvailableViews = this.viewsLocal;
      return;
    }

    this.allAvailableViews = this.viewsLocal.filter(view =>
      view.name.toLowerCase().startsWith(keyWord.toLowerCase())
    );
  }

  @Watch("views", { deep: true })
  listenChangeViews() {
    this.allAvailableViews = this.viewsLocal;
  }
}
